Vue.component("image-slider-pro", {
    template: `<div class="slider-pro" ref="slider">
        <div class="sp-slides">
            <slot></slot>
        </div>
    </div>`,

    props: {
        sliderOptions: {
            type: Object,
            default: () => ({
                width: "100%",
                autoHeight: true,
                loop: true,
                arrows: true,
                buttons: true,
                waitForLayers: true,
                autoplay: true,
                autoplayDelay: 5000,
                autoScaleLayers: false,
                smallSize: 576,
                mediumSize: 992,
                largeSize: 1200,
                keyboard: false,
                reachVideoAction: "playVideo",
                heightAnimationDuration: 0
            })
        }
    },

    mounted()
    {
        this.$nextTick(() =>
        {
            this.initializeCarousel();
        });
    },

    methods: {
        initializeCarousel()
        {
            if (App.isShopBuilder)
            {
                this.sliderOptions.autoplay = false;
            }

            if (!App.isShopBuilder)
            {
                const isMobile = window.matchMedia("(max-width: 768px)").matches;

                if (isMobile)
                {
                    $(this.$refs.slider).find(".sp-slide[data-mob-only]").remove();
                }
            }
            if ($(this.$refs.slider).find(".sp-slides").children().length <= 1)
            {
                this.sliderOptions.loop = false;
                this.sliderOptions.arrows = false;
            }
            $(this.$refs.slider).sliderPro(this.sliderOptions);
        }
    }
});

$(function()
{
    const navbarMenu = document.querySelector(".navbar-menu:not(.unfixed)");

    if (navbarMenu)
    {
        const navbarMenuObserver = new MutationObserver((mutations) =>
        {
            mutations.forEach((mutationRecord) =>
            {
                if (navbarMenu.style.top == "0px")
                {
                    navbarMenu.classList.add("sticky");
                }
                else
                {
                    navbarMenu.classList.remove("sticky");
                }
            });
        });

        navbarMenuObserver.observe(navbarMenu, { attributes: true, attributeFilter: ["style"] });
    }

    const navbarMobileMenu = document.querySelector(".navbar-mobile-menu:not(.unfixed)");

    if (navbarMobileMenu)
    {
        const navbarMobileMenuObserver = new MutationObserver((mutations) =>
        {
            mutations.forEach((mutationRecord) =>
            {
                if (navbarMobileMenu.style.top == "0px")
                {
                    navbarMobileMenu.classList.add("sticky");
                }
                else
                {
                    navbarMobileMenu.classList.remove("sticky");
                }
            });
        });

        navbarMobileMenuObserver.observe(navbarMobileMenu, { attributes: true, attributeFilter: ["style"] });
    }

    $(document).on("mouseenter mouseleave", ".cmp-product-thumb", function()
    {
        $(this).find(".owl-carousel").trigger("refresh.owl.carousel");
    });

    if (ThemeConfig.header.enableDropLeft === true || ThemeConfig.header.enableDropLeft == "true")
    {
        $("body").on("mouseover", ".main-navbar-collapsable.normalmenu .mainmenu > li.ddown", function()
        {
            const item = $(this);
            const distanceConfig = parseInt(ThemeConfig.header.dropLeftOffset);
            const windowWidth = $(window).width();
            const rightDistance = windowWidth - (item.offset().left + item.outerWidth());

            if (rightDistance < distanceConfig)
            {
                item.addClass("drop-left");
            }
            else
            {
                item.removeClass("drop-left");
            }
        });
    }

    /* Search */
    $(".search__trigger").on("click", function(event)
    {
        event.preventDefault();
        if ($(this).hasClass("opened"))
        {
            $(this).removeClass("opened");
            $(this).find(".pl-outline-clear").removeClass("pl-outline-clear").addClass("pl-baseline-search");
            $(this).parent(".search").removeClass("open");
            $(this).next(".search-dropdown").removeClass("open");
        }
        else
        {
            $(this).addClass("opened");
            $(this).find(".pl-baseline-search").removeClass("pl-baseline-search").addClass("pl-outline-clear");
            $(this).parent(".search").addClass("open");
            $(this).next(".search-dropdown").addClass("open");
        }
    });

    /* Slider-Pro Shopbuilder */
    if (App.isShopBuilder)
    {
        setTimeout(() =>
        {
            $(".slider-pro").sliderPro("update");
        }, 2000);
    }
    $("body").on("click", ".slider-pro-reload", function()
    {
        $(".slider-pro").sliderPro("update");
        return false;
    });

    $("body").on("click", ".slider-pro-switch", function()
    {
        const id = $(this).attr("data-slide");
        const widget = $(this).closest(".widget-slider-container");

        widget.find(".slider-pro-switch").removeClass("active");
        $(this).addClass("active");
        if (id)
        {
            widget.find(".slider-pro").sliderPro("gotoSlide", id);
        }
        return false;
    });

    /* Fake filter */
    $(".fake-filter-toggle").on("click", function()
    {
        $("body").addClass("menu-is-visible");
        $(".customf-side-bar").addClass("open");

        return false;
    });
    $(".customf-side-bar-close").on("click", function()
    {
        $("body").removeClass("menu-is-visible");
        $(".customf-side-bar").removeClass("open");
    });

    /* Collapse block */
    $(".collapse-block__content").each(function()
    {
        if ($(this).parent(".collapse-block").hasClass("open"))
        {
            $(this).slideDown(0);
        }
    });

    $("body").on("click", ".collapse-block__title", function(event)
    {
        event.preventDefault();
        const speed = 300;
        const thisItem = $(this).parent();
        const nextLevel = $(this).next(".collapse-block__content");

        if (thisItem.hasClass("open"))
        {
            thisItem.removeClass("open");
            nextLevel.slideUp(speed);
        }
        else
        {
            thisItem.addClass("open");
            nextLevel.slideDown(speed);
        }
    });

    $(".dropdown-menu__close").on("click", function(event)
    {
        event.preventDefault();
        $(this).closest(".dropdown.open .dropdown-toggle").dropdown("toggle");
    });

    $("body").on("click", ".btn[data-toggle='modal'][href='#login']", function()
    {
        window.ceresStore.dispatch("loadComponent", "login-modal");
    });

    $("body").on("click", ".item-set-description .description-trigger", function()
    {
        const modalContent = $(this).closest(".item-set-description").find(".description-content").html();

        if (modalContent.trim())
        {
            $("#item-set-desc-modal-wrapper .modal-body").html(modalContent);
            $("#item-set-desc-modal-wrapper .item-set-desc-modal").modal("show");
        }

        return false;
    });
});
